import React from 'react';
import PropTypes from 'prop-types';
import Avatar from './Avatar';
import { getColor } from '../color';

import '../css/user.scss';

const User = ({ name, avatar, userId, border, displace }) => {
  const color = getColor(userId);
  const style = { color };

  if (displace) {
    style.marginLeft = '-10px';
  }

  return (
    <div className="" style={style}>
      <Avatar
        title={name || `User ${userId}`}
        src={avatar}
        style={{ backgroundColor: color }}
        border={border}
      />
    </div>
  );
};

User.defaultProps = {
  avatar: null,
  border: false,
  displace: false,
};

User.propTypes = {
  name: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  avatar: PropTypes.string,
  border: PropTypes.bool,
  displace: PropTypes.bool,
};

export default User;
